import { render } from "./Paragraph.vue?vue&type=template&id=a0d74b24"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a0d74b24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0d74b24', script)) {
    api.reload('a0d74b24', script)
  }
  
  module.hot.accept("./Paragraph.vue?vue&type=template&id=a0d74b24", () => {
    api.rerender('a0d74b24', render)
  })

}

script.__file = "src/components/Paragraph.vue"

export default script